export default __webpack_public_path__ + "static/media/center-left-red.cb84dd21.png";